import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CourseService } from 'src/app/shared/services/course.service';
// import { CourseService } from 'src/app/services/course.service';
// import { debug } from 'util';

@Component({
  selector: 'app-unanswered-modal',
  templateUrl: './unanswered-modal.component.html',
  styleUrls: ['./unanswered-modal.component.css']
})
export class UnansweredModalComponent implements OnInit {

  @Output() onSubmit = new EventEmitter<boolean>();
  @Output() onBack = new EventEmitter<boolean>();
  @Input() data: any;
  constructor(public activeModal: NgbActiveModal, private courseService: CourseService) { }

  ngOnInit() {
  }
  submit() {
    this.onSubmit.emit(true);
    this.activeModal.dismiss();
  }

  goBack(){
    this.onBack.emit(true);
    this.activeModal.dismiss();
  }
}
